import numeral from 'numeral'

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function formatDateLabel(isoDate) {
  const [, month, day] = isoDate.split('-')
  return `${MONTH_NAMES[parseInt(month, 10) - 1]} ${parseInt(day, 10)}`
}

export function formatMetricValue(value, metricType, includeUnit = false) {
  if (metricType === 'earnings') {
    return `$${numeral(value).format('0,0.00')}`
  }
  const formatted = numeral(value).format('0,0')
  return includeUnit ? `${formatted} views` : formatted
}

export function formatTickValue(value, metricType) {
  const format = metricType === 'earnings' ? '$0,0a' : '0,0a'
  return numeral(value).format(format)
}
